export const QUANTITATIVE = 'qn'
export const QUALITATIVE = 'ql'
